import { useCallback } from 'react';
import { useDataPortalStore } from '../store/dataPortalStore';

/**
 * 拉取「数据门户」菜单信号（灰度开关 + 可见看板）。
 *
 * 实际逻辑在 `store/dataPortalStore` 里，这里只是保留一个 hook 形态的入口，
 * 让 App / LoginPage / 配置页沿用原来的调用方式。store 更新会自动触发菜单重渲染，
 * 调用方**不再需要 await 它才 navigate**。
 */
export function useFetchDataPortal() {
    const refresh = useDataPortalStore((s) => s.refresh);
    const refreshMenu = useDataPortalStore((s) => s.refreshMenu);
    // fetchDataPortal：全量（含灰度），进模块/登录用；refreshMenu：轻量（只菜单），管理页操作后用
    const fetchDataPortal = useCallback(() => refresh(), [refresh]);
    return { fetchDataPortal, refreshMenu };
}
